import { useState, useEffect } from 'react'
import axios from 'axios'
import { hablar } from '../utils/audioHelper'

const API = process.env.REACT_APP_API_URL

const COLORES_NIVEL = {
  PRE: '#94A3B8', A1: '#22C55E', A2: '#3B82F6', B1: '#8B5CF6', B2: '#F59E0B', C1: '#EF4444'
}
const NIVELES = ['Todos', 'PRE', 'A1', 'A2', 'B1', 'B2', 'C1']

const COLOR_DIFICULTAD = { Facil: '#22C55E', Medio: '#F59E0B', Dificil: '#EF4444' }
const DIFICULTADES = ['Todos', 'Facil', 'Medio', 'Dificil']

const NOMBRE_CATEGORIA_PROV = {
  motivacion: 'Motivación', sabiduria: 'Sabiduría', disciplina: 'Disciplina',
  exito: 'Éxito', mentalidad_crecimiento: 'Mentalidad de crecimiento'
}
const CATEGORIAS_PROV = ['Todos', 'motivacion', 'sabiduria', 'disciplina', 'exito', 'mentalidad_crecimiento']

function BotonAudio({ texto, tamano = 30 }) {
  return (
    <button onClick={() => hablar(texto)}
      style={{ background: '#E8EFFE', border: 'none', borderRadius: '50%', width: tamano, height: tamano, cursor: 'pointer', fontSize: tamano * 0.45, flexShrink: 0 }}>
      🔊
    </button>
  )
}

function FiltrosPestana({ opciones, activo, onCambiar, nombres, colores }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
      {opciones.map(o => (
        <button key={o} onClick={() => onCambiar(o)}
          style={{
            padding: '7px 16px', borderRadius: 999, border: '1.5px solid ' + (activo === o ? (colores?.[o] || 'var(--azul)') : 'var(--gris-borde)'),
            background: activo === o ? (colores?.[o] || 'var(--azul)') : '#fff', color: activo === o ? '#fff' : 'var(--gris-texto)',
            fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer'
          }}>
          {nombres?.[o] || o}
        </button>
      ))}
    </div>
  )
}

/* ── Trabalenguas ─────────────────────────────────────────── */
function Trabalenguas() {
  const [cargando, setCargando] = useState(true)
  const [datos,    setDatos]    = useState([])
  const [filtro,   setFiltro]   = useState('Todos')
  const [error,    setError]    = useState(null)

  useEffect(() => {
    setCargando(true)
    axios.get(`${API}/lecturas/trabalenguas`).then(res => {
      setDatos(res.data.datos || [])
    }).catch(err => {
      console.error('Error cargando trabalenguas:', err)
      setError('No pudimos cargar los trabalenguas. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [])

  const visibles = filtro === 'Todos' ? datos : datos.filter(t => t.dificultad === filtro)

  if (cargando) return <div style={{ textAlign: 'center', padding: '50px 20px', color: 'var(--gris-texto)' }}>Cargando trabalenguas...</div>
  if (error) return <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>

  return (
    <div>
      <FiltrosPestana opciones={DIFICULTADES} activo={filtro} onCambiar={setFiltro} colores={COLOR_DIFICULTAD} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {visibles.map(t => (
          <div key={t.id} style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16, padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 }}>
              <span style={{ background: (COLOR_DIFICULTAD[t.dificultad] || 'var(--azul)') + '20', color: COLOR_DIFICULTAD[t.dificultad] || 'var(--azul)', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
                {t.dificultad}
              </span>
              <BotonAudio texto={t.texto} />
            </div>
            <p style={{ fontSize: 16, fontWeight: 700, color: 'var(--azul-oscuro)', lineHeight: 1.5, marginBottom: 8, whiteSpace: 'pre-line' }}>{t.texto}</p>
            <p style={{ fontSize: 13, color: 'var(--gris-texto)', whiteSpace: 'pre-line', lineHeight: 1.5 }}>{t.traduccion}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

/* ── Cuentos Cortos ───────────────────────────────────────── */
function Cuentos({ usuario, onCambio }) {
  const [cargando,  setCargando]  = useState(true)
  const [lista,     setLista]     = useState([])
  const [filtro,    setFiltro]    = useState('Todos')
  const [error,     setError]     = useState(null)
  const [activo,    setActivo]    = useState(null)   // detalle del cuento abierto
  const [cargandoDetalle, setCargandoDetalle] = useState(false)

  useEffect(() => {
    setCargando(true)
    axios.get(`${API}/lecturas/cuentos`).then(res => {
      setLista(res.data.datos || [])
    }).catch(err => {
      console.error('Error cargando cuentos:', err)
      setError('No pudimos cargar los cuentos. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [])

  function abrirCuento(id) {
    setCargandoDetalle(true)
    const usuarioId = usuario?.id ? `?usuario_id=${usuario.id}` : ''
    axios.get(`${API}/lecturas/cuentos/${id}${usuarioId}`).then(res => {
      setActivo(res.data.cuento)
      // Da tiempo a que el servidor registre la lectura y el XP
      // antes de refrescar las estadisticas del dashboard.
      if (onCambio) setTimeout(onCambio, 1500)
    }).catch(err => {
      console.error('Error cargando cuento:', err)
    }).finally(() => setCargandoDetalle(false))
  }

  if (activo) {
    return (
      <div>
        <button onClick={() => setActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', marginBottom: 18, padding: 0 }}>
          ← Volver a cuentos
        </button>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <span style={{ background: COLORES_NIVEL[activo.nivel] || 'var(--azul)', color: '#fff', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
            {activo.nivel}
          </span>
          <span style={{ fontSize: 12, color: 'var(--dorado)', fontWeight: 700 }}>+{activo.xp} XP</span>
        </div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: 'var(--azul-oscuro)', margin: '8px 0 20px' }}>{activo.titulo}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {(activo.contenido?.parrafos || []).map((p, i) => (
            <div key={i} style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 14, padding: 18 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 8 }}>
                <p style={{ fontSize: 14.5, color: '#1A1A2E', lineHeight: 1.55, flex: 1 }}>{p.en}</p>
                <BotonAudio texto={p.en} tamano={26} />
              </div>
              <p style={{ fontSize: 12.5, color: 'var(--gris-texto)', lineHeight: 1.5, fontStyle: 'italic' }}>{p.es}</p>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const visibles = filtro === 'Todos' ? lista : lista.filter(c => c.nivel === filtro)

  if (cargando) return <div style={{ textAlign: 'center', padding: '50px 20px', color: 'var(--gris-texto)' }}>Cargando cuentos...</div>
  if (error) return <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>

  return (
    <div>
      <FiltrosPestana opciones={NIVELES} activo={filtro} onCambiar={setFiltro} colores={COLORES_NIVEL} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: 16 }}>
        {visibles.map(c => (
          <button key={c.id} onClick={() => abrirCuento(c.id)} disabled={cargandoDetalle}
            style={{ textAlign: 'left', background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16, overflow: 'hidden', cursor: cargandoDetalle ? 'default' : 'pointer', padding: 0, fontFamily: 'inherit' }}>
            <div style={{ height: 5, background: COLORES_NIVEL[c.nivel] || 'var(--azul)' }} />
            <div style={{ padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <span style={{ background: COLORES_NIVEL[c.nivel] || 'var(--azul)', color: '#fff', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
                  {c.nivel}
                </span>
                <span style={{ fontSize: 11, color: 'var(--dorado)', fontWeight: 700 }}>+{c.xp} XP</span>
              </div>
              <h3 style={{ fontSize: 16, fontWeight: 800, color: 'var(--azul-oscuro)', marginBottom: 6 }}>{c.titulo}</h3>
              <p style={{ fontSize: 12.5, color: 'var(--gris-texto)', lineHeight: 1.4 }}>{c.resumen}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

/* ── Proverbios / Mindset ─────────────────────────────────── */
function Proverbios() {
  const [cargando, setCargando] = useState(true)
  const [datos,    setDatos]    = useState([])
  const [filtro,   setFiltro]   = useState('Todos')
  const [error,    setError]    = useState(null)

  useEffect(() => {
    setCargando(true)
    axios.get(`${API}/lecturas/proverbios`).then(res => {
      setDatos(res.data.datos || [])
    }).catch(err => {
      console.error('Error cargando proverbios:', err)
      setError('No pudimos cargar los proverbios. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [])

  const visibles = filtro === 'Todos' ? datos : datos.filter(p => p.categoria === filtro)

  if (cargando) return <div style={{ textAlign: 'center', padding: '50px 20px', color: 'var(--gris-texto)' }}>Cargando proverbios...</div>
  if (error) return <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>

  return (
    <div>
      <FiltrosPestana opciones={CATEGORIAS_PROV} activo={filtro} onCambiar={setFiltro} nombres={NOMBRE_CATEGORIA_PROV} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {visibles.map(p => (
          <div key={p.id} style={{ background: 'linear-gradient(135deg,#F8FAFF,#fff)', border: '1px solid var(--gris-borde)', borderRadius: 16, padding: 20 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 12 }}>
              <span style={{ background: '#F0F4FF', color: 'var(--azul)', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 999 }}>
                {NOMBRE_CATEGORIA_PROV[p.categoria] || p.categoria}
              </span>
              <BotonAudio texto={p.frase} />
            </div>
            <p style={{ fontSize: 16, fontWeight: 700, color: 'var(--azul-oscuro)', lineHeight: 1.4, marginBottom: 10, fontStyle: 'italic' }}>"{p.frase}"</p>
            <p style={{ fontSize: 13, color: 'var(--gris-texto)' }}>{p.significado}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

/* Pagina de "Lecturas": trabalenguas, cuentos cortos y
   proverbios/mindset, todo en ingles con traduccion y audio. */
export default function Lecturas({ usuario, onCambio }) {
  const [pestana, setPestana] = useState('trabalenguas') // 'trabalenguas' | 'cuentos' | 'proverbios'

  const TABS = [
    { id: 'trabalenguas', etiqueta: '🌀 Trabalenguas' },
    { id: 'cuentos',      etiqueta: '📖 Cuentos Cortos' },
    { id: 'proverbios',   etiqueta: '💭 Proverbios & Mindset' }
  ]

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 960 }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800 }}>📚 Lecturas</h1>
        <p style={{ color: 'var(--gris-texto)', fontSize: 14, marginTop: 4 }}>
          Practica tu ingles leyendo y escuchando: trabalenguas, cuentos cortos y frases de mentalidad, todo con traduccion.
        </p>
      </div>

      <div style={{ display: 'flex', background: '#F0F2F8', border: '1px solid var(--gris-borde)', borderRadius: 10, overflow: 'hidden', marginBottom: 24, maxWidth: 520 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setPestana(t.id)}
            style={{ flex: 1, padding: '9px 6px', border: 'none', background: pestana === t.id ? 'var(--azul)' : 'transparent',
              color: pestana === t.id ? '#fff' : 'var(--gris-texto)', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
            {t.etiqueta}
          </button>
        ))}
      </div>

      {pestana === 'trabalenguas' && <Trabalenguas />}
      {pestana === 'cuentos' && <Cuentos usuario={usuario} onCambio={onCambio} />}
      {pestana === 'proverbios' && <Proverbios />}
    </div>
  )
}
